import React from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action

import Cookies from 'js-cookie';

import './writeart.css'
import { NetPost } from '../../axios'
import { toast } from 'react-toastify'
import CodeBack from './code-block'
import Login from '../../components/com_login'
import { reSetBar } from '../../tool/reSetBar';
// import CodeBack from './code-block'
const Editor = require('./editor')

// import { setPageTitle } from '../../store/actions.js'
const ReactMarkdown = require('react-markdown')
const customRenderers = {
    // image: ({src, alt}) => {
    //   return <a rel="nofollow" href={src}>{alt}</a>
    // },
    // link: ({href, children}) => {
    //   return <a rel="nofollow" href={href}>{children[0]}</a>;
    // },
    code:({value}) => {
        return <CodeBack value={value}/>
      },
    paragraph: ({ children }) => {

        
        var reslist = []
        Array.from(children).forEach((e, i) => {
            if (typeof(e.type.name)=="string") {
                try {
                    var joindom = e.props.value.split("\n")
                joindom = joindom.map((e, i) => <>{e}{(i !== joindom.length - 1) && <br />}</>)
                reslist.push(...joindom)
                } catch (error) {
                    
                }
                
            } else {
                reslist.push(e)
            }
        })

        //console.log(children)
        return <p>{reslist}</p>;
    }
}

class Writeart extends React.PureComponent {
    state = {
        title: "",
        data: ""
    }
  
    opencode = true
    componentDidMount() {
        reSetBar()
        this.node.scrollIntoView();
        document.querySelector(".headerbox").parentNode.style.display = "none"

    }



    componentWillUnmount() {
        document.querySelector(".headerbox").parentNode.style.display = "block"
    }


    // setTime=()=>{
    //     console.log(this.timer)
    //     if(this.timer){
    //         this.timer=false
    //         clearTimeout(this.timer)
    //     }else{
    //         this.timer=setTimeout(()=>{
    //             this.setState({
    //                 data:this.textarea.value
    //             })
    //         },2000)
    //     }

    // }

    onChange = (e, ispasteimg) => {
        var newdata = ''
        if (ispasteimg) {
            newdata = this.state.data
            newdata = newdata + e.target.value
        } else {
            newdata = e.target.value
        }

        this.setState({
            data: newdata
        })
    }
    titleChange = () => {
        this.setState({

            title: this.input.value
        })
    }


    setupImage = (e, todata) => {
        const { data } = this.state
        if (this.state.data.indexOf(e) >= 0) {
            var newdata = data
            newdata = data.replace(e, todata)
            this.setState({
                data: newdata
            })
        }
    }


    getToken=()=>{
        return Cookies.get("userinfo") ? JSON.parse(Cookies.get("userinfo")).token : ''
    }


    postArt=()=>{
        
        if (!this.opencode) { return false }
        this.opencode = false
        const inputV = this.input.value
        const textareaV = this.state.data
        const sort_nameV = "默认分类"
        if (!inputV || !textareaV || !sort_nameV) {
            this.opencode = true
            return toast.error(`都必须填写!`);

        }
        this.showUPIMG(false)
        let param = new URLSearchParams()
        param.append('title', inputV)

        param.append('body', textareaV)
        param.append('sort_name', sort_nameV)
        if(this.posvimg){
            param.append('posvimg', this.posvimg) 
        }
        param.append('token', this.getToken())
        NetPost("addart", param)
            .then((e) => {
                this.opencode = true
                if (e.code == 0) {
                    this.setState({
                        data: '',
                        title: ''
                    })
                    this.input.value = ''
                    toast.success("文章发布成功 !");


                } else {
                    if (e.code == -2) {
                        this.setLogin(true)
                    }
                    toast.error(e.msg);

                }


            })
            .catch((e) => {
                this.opencode = true

                toast.error("发布失败 !");
            })
    }


    submit = () => {
        
  
        const inputV = this.input.value
        const textareaV = this.state.data
        const sort_nameV = "默认分类"
        if (!inputV || !textareaV || !sort_nameV) {
           
            return toast.error(`都必须填写!`);

        }
        this.showUPIMG(true)
    }

    setLogin = (e) => {
        this.setState({
            login: e
        })
    }
    PostFile=(file,filename )=>{
        var form = new FormData();
            form.append("file", file)
            form.append("token", this.getToken())
            form.append("filename", filename)
        this.setState({
            loading:true
        })
        NetPost("/upartcoverimg",form)
        .then((e)=>{
            this.setState({
                loading:false
            },()=>{
                if(e.code==0){
                    this.posvimg=e.img
                    this.nowimg.style.backgroundImage="url("+this.posvimg+")"
                    //this.showUPIMG(false)//关闭上传图片
                    //this.postArt()//发布文章
                }else{
                    toast.error(`图片上传失败!`);
                }
            })
            
            
        })
        .catch(()=>{
            this.setState({
                loading:false
            })
        })
    }
    onupInput=()=>{
        var file = this.upinput.files[0];
        var filename = file.name
        console.log(file)
        
        if (file.type.split("/")[0] != "image") {
         
            //选择的文件类型不是图片向RN发送状态码1009 rn判断是1009就提示不支持此格式
            alert("请选择图片")
        } else {
            this.PostFile(file, filename);
        }
    }

    showUPIMG=(e)=>{
        this.setState({showup:e})
    }
    render() {
        const { data, title,showup ,loading} = this.state
        return (
            <div className="writeart-box" ref={(ref) => this.node = ref}>

                <div className="writeart-left" style={{backgroundColor:"#fff"}}>

                    <input
                    
                        placeholder="文章标题"
                        ref={(ref) => this.input = ref}
                        onChange={this.titleChange} />
                    <div className="writeart-btn">
                        <span onClick={() => { window.location.href="javascript:history.go(-1)"; }}>返回上一页</span>
                        <span onClick={this.submit}>发布文章</span>
                    </div>
                    <Editor value={data} onChange={this.onChange} setupImage={this.setupImage} />
                </div>
                <div className="writeart-right mark-down">
                    <h2 className="art_title">{title}</h2>
                    <ReactMarkdown
                    children ={data}
                    escapeHtml={false}
                    skipHtml={false}
                    components={{ code: (value)=>{
                        return <CodeBack value={value.children} className={value.className}/>
                    } }}
                    // renderers={customRenderers}
                />
                        {/* <ReactMarkdown
                            children={data}
                            escapeHtml={false}
                            skipHtml={false}
                            components={{ code: CodeBack }}

                        /> */}
                    {/* <ReactMarkdown
                        source={data}
                        escapeHtml={false}
                        skipHtml={false}
                        renderers={{ code: CodeBack }}

                    /> */}
                </div>

                {
                    showup&&<div className="upimg-box">
                        <div>
                            <div className="up-title">
                                <h1>请上传文章封面图片</h1>
                            </div>
                            <div class="m">
                                <div class="right_btn">
                                    <a href="javascript:;" class="file">
                                        {
                                            loading
                                            ?
                                            <div className="nowimgload">
                                            <svg 
                                            className="loadsvg" t="1609491884831"  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1978"
                                             width="36%" height="36%">
                                                 <path d="M391.168 571.392l11.776-11.776V432.128c0-11.264 4.096-21.504 10.752-29.696L445.44 363.52c6.144-7.68 15.872-12.8 26.624-12.8h249.344c-1.536-2.048-2.56-4.608-4.608-6.144l-32.256-38.912c-6.656-7.68-16.384-12.8-27.136-12.8H379.392c-10.752 0-20.48 5.12-26.624 12.8l-32.256 38.912c-6.656 8.192-10.752 18.432-10.752 29.696v290.304c0 25.6 20.992 46.592 46.592 46.592h46.592v-139.264h-11.776z m-13.312-255.488h278.528l21.504 23.04H358.912l18.944-23.04z" fill="#FFCB99" p-id="1979"></path><path d="M452.096 397.312h275.456V373.76H471.04zM594.432 519.168l52.224 52.224h-81.408V710.656h92.672v-81.408h69.632v-11.776L611.84 501.76z" fill="#FFCB99" p-id="1980"></path><path d="M657.92 710.656h23.04c25.6 0 46.592-20.992 46.592-46.592v-34.816h-69.632v81.408z" fill="#FF7E00" p-id="1981"></path><path d="M809.984 402.432l-32.256-38.912c-6.656-7.68-16.384-12.8-27.136-12.8H472.064c-10.752 0-20.48 5.12-26.624 12.8l-32.256 38.912c-6.656 8.192-10.752 18.432-10.752 29.696V722.432c0 25.6 20.992 46.592 46.592 46.592h325.12c25.6 0 46.592-20.992 46.592-46.592V432.128c0-11.264-4.096-21.504-10.752-29.696z m-82.432 226.816v34.816c0 25.6-20.992 46.592-46.592 46.592h-115.712V629.76H483.84l110.08-110.08 17.408-17.408 116.224 116.224 11.776 11.776h-11.776z m0-231.936H452.096L471.04 373.76h278.528l21.504 23.04h-43.52z" fill="#FF7E00" p-id="1982"></path><path d="M226.304 553.984h-29.696v-29.696c0-6.656-5.12-11.776-11.776-11.776s-11.776 5.12-11.776 11.776v29.696H143.36c-6.656 0-11.776 5.12-11.776 11.776s5.12 11.776 11.776 11.776h29.696v29.696c0 6.656 5.12 11.776 11.776 11.776s11.776-5.12 11.776-11.776v-29.696h29.696c6.656 0 11.776-5.12 11.776-11.776s-5.12-11.776-11.776-11.776zM811.52 195.584c14.848 14.848 10.24 33.792 6.656 47.616-3.584 13.824-4.096 20.48 0.512 25.6 5.12 5.12 11.264 4.096 25.6 0.512 13.824-3.584 32.768-8.192 47.616 6.656 14.848 14.848 10.24 33.28 6.656 47.104-3.584 13.824-4.608 20.48 0.512 25.6 4.608 4.608 4.608 11.776 0 16.384-4.608 4.608-11.776 4.608-16.384 0-14.848-14.848-10.24-33.28-6.656-47.104 3.584-13.824 4.608-20.48-0.512-25.6s-11.264-4.096-25.6-0.512c-13.824 3.584-32.768 8.192-47.104-6.656-14.848-14.848-10.24-33.792-6.656-47.616 3.584-13.824 4.608-20.48-0.512-25.6s-11.776-4.096-25.6-0.512c-13.824 3.584-32.768 8.192-47.616-6.656-4.608-4.608-4.608-11.776 0-16.384 4.608-4.608 11.776-4.608 16.384 0 5.12 5.12 11.264 4.096 25.6 0.512 13.312-3.072 32.256-7.68 47.104 6.656z" fill="#FFC879" p-id="1983"></path><path d="M878.08 652.8h65.536v65.536h-65.536zM230.4 386.048l34.816-35.328H195.584z" fill="#FFF7EC" p-id="1984"></path><path d="M330.752 773.12l-49.664-49.664c-3.584-3.584-9.216-3.584-12.8 0l-49.664 49.664c-3.584 3.584-3.584 9.216 0 12.8l49.664 49.664c3.584 3.584 9.216 3.584 12.8 0l49.664-49.664c3.584-3.072 3.584-9.216 0-12.8z m-56.32 43.52l-36.864-36.864 36.864-36.864 36.864 36.864-36.864 36.864z" fill="#FFC879" p-id="1985"></path></svg>
                                        </div>
                                            :
                                        <>
                                        <input
                                        ref={(e)=>this.upinput=e}
                                        onChange={this.onupInput}
                                        type="file" name="slice" id="slice" accept="image/*" capture="camcorder" />
                                        <div ref={(e)=>this.nowimg=e} className="nowimg"></div>
                                        </>
                                       }
                                        

                                    </a>
                                </div>
                            </div>
                            <div className="subbtn_box">
                                <div className="subbtn" onClick={()=>this.postArt()}>
                                    立即发布
                                </div>
                                <div onClick={()=>this.showUPIMG(false)} className="btngo-on">
                                    继续编辑
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {
                    this.state.login && <Login setLogin={this.setLogin} />
                }


            </div>
        )
    }
}



export default connect()(Writeart)